import {
    APIProvider
} from '@vis.gl/react-google-maps';
import React from 'react';
import { googleMapSlice } from '../../common/store/googleMapSlice';
import { appStore } from '../../common/store/store';

export default (props: { children?: React.ReactNode | React.ReactNode[]; }) => {
    const GOOGLE_MAPS_API_KEY = 'AIzaSyBeP2aQ3cEN38cc639OMdaI_ZZEVfpQMPc';
    const onLibraryLoaded = () => {
        appStore.dispatch(googleMapSlice.actions.setLoaded(true));
    };
    return <APIProvider onLoad={onLibraryLoaded} libraries={['drawing']} apiKey={GOOGLE_MAPS_API_KEY}>{props.children}</APIProvider>;
};
